import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/security/perfilopciones/filterPerfilOpciones'; // Importing Filter component
import Table from 'views/security/perfilopciones/tablePerfilOpciones'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the PerfilOpcionesView.
 * @extends JetView
 */
export default class PerfilOpcionesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            css: 'int-left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label element in the toolbar
                            align: 'center', // Center alignment
                            label: _('Perfil Opciones'), // Translated label text
                        },
                        {
                            type: 'wide', // Wide type for the button container
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon button for closing
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Icon width
                                    height: 30, // Icon height
                                    click: () => this.show('/top/dashboard'), // Click event to navigate
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including the Filter component
                Table, // Including the Table component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Vertical scrolling enabled
            rows: [
                {
                    responsive: 'a5', // Responsive design for the row
                    type: 'wide', // Wide type for the column
                    cols: [left], // Left column containing the toolbar, filter, and table
                },
            ],
        };
    }
}

// FILE DOCUMENTED
